import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import Headers from '../components/Headers'
import Footer from '../components/Footer'
import { CheckCircle, XCircle, Loader2 } from 'lucide-react'

const PaymentCallback = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [status, setStatus] = useState('processing')

    const txStatus = searchParams.get('status')
    const txRef = searchParams.get('tx_ref')

    useEffect(() => {
        if (txStatus === 'successful' || txStatus === 'completed') {
            setStatus('success')
            // Redirect to dashboard after 3 seconds
            const timer = setTimeout(() => navigate('/dashboard/my-orders'), 3000)
            return () => clearTimeout(timer)
        } else if (txStatus === 'cancelled') {
            setStatus('cancelled')
        } else {
            setStatus('failed')
        }
    }, [txStatus, navigate])

    return (
        <div className='w-full'>
            <Headers />
            <div className='w-[85%] mx-auto py-20'>
                <div className='bg-white rounded-lg p-10 max-w-md mx-auto text-center'>
                    {status === 'success' && (
                        <>
                            <CheckCircle className='mx-auto mb-4 text-green-500' size={64} />
                            <h1 className='text-2xl font-bold text-gray-900 mb-2'>Payment Successful!</h1>
                            <p className='text-gray-600 mb-4'>Your payment has been received and is being processed.</p>
                            <p className='text-sm text-gray-400'>Reference: {txRef}</p>
                            <p className='text-sm text-gray-400 mt-2'>Redirecting to your orders...</p>
                        </>
                    )}
                    {status === 'cancelled' && (
                        <>
                            <XCircle className='mx-auto mb-4 text-yellow-500' size={64} />
                            <h1 className='text-2xl font-bold text-gray-900 mb-2'>Payment Cancelled</h1>
                            <p className='text-gray-600 mb-4'>You cancelled the payment. No charges were made.</p>
                            <button
                                onClick={() => navigate(-1)}
                                className='px-6 py-2 bg-black text-white rounded-md hover:bg-gray-800'
                            >
                                Go Back
                            </button>
                        </>
                    )}
                    {status === 'failed' && (
                        <>
                            <XCircle className='mx-auto mb-4 text-red-500' size={64} />
                            <h1 className='text-2xl font-bold text-gray-900 mb-2'>Payment Failed</h1>
                            <p className='text-gray-600 mb-4'>Something went wrong with your payment. Please try again.</p>
                            <button
                                onClick={() => navigate(-1)}
                                className='px-6 py-2 bg-black text-white rounded-md hover:bg-gray-800'
                            >
                                Try Again
                            </button>
                        </>
                    )}
                    {status === 'processing' && (
                        <>
                            <Loader2 className='mx-auto mb-4 text-gray-400 animate-spin' size={64} />
                            <h1 className='text-2xl font-bold text-gray-900 mb-2'>Processing...</h1>
                            <p className='text-gray-600'>Please wait while we verify your payment.</p>
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PaymentCallback
